<template>
  <b-modal ref="modal" hide-footer centered title="Add New Sub Page">
    <b-form @submit.prevent="save">
      <b-form-group label="Title:">
        <b-form-input
          v-model="$v.title.$model"
          :class="{ 'is-invalid': $v.title.$error }"
          :disabled="inProgress"
        />
        <b-form-invalid-feedback v-if="!$v.title.required">Title is required</b-form-invalid-feedback>
        <b-form-invalid-feedback
          v-if="!$v.title.isUnique"
        >There's a Table with the same title already exists</b-form-invalid-feedback>
        <b-form-invalid-feedback
          v-if="!$v.title.alphaNum"
        >Table title accepts only alphanumerics and can not start with number or dash sign</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <b-form-checkbox v-model="createTable" :disabled="inProgress">
          <span>Create Table</span>
        </b-form-checkbox>
      </b-form-group>
      <div>
        <b-button type="submit" variant="primary" :disabled="inProgress">
          <span>Save</span>
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
import { required, helpers } from 'vuelidate/lib/validators'
const alphaNum = helpers.regex('alphaNum', /^[A-Za-z][A-Za-z0-9_-\s]*$/)
// services
import db from '@/services/db'
// helpers
import eventBus from '@/helpers/event-bus'

export default {
  props: ['subTabs'],
  data() {
    return {
      title: null,
      createTable: false,
      inProgress: false,
      manualTab: null,
    }
  },
  computed: {
    ...mapState(['currentTab', 'dataGrid_options']),
  },
  methods: {
    open() {
      if (this.$refs.modal) this.$refs.modal.show()
    },
    close() {
      this.manualTab = null
      if (this.$refs.modal) this.$refs.modal.hide()
    },
    async save() {
      if (this.inProgress) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inProgress = true

      const data = {
        title: this.title,
        count: this.$count(this.subTabs) ? this.$count(this.subTabs) : 0,
      }

      const subTab = await new Promise(resolve => {
        db.tabs.createSubTab(
          this.manualTab || this.currentTab,
          data,
          newSubTabKey => {
            this.inProgress = false
            if (!this.createTable) this.title = null

            this.$emit('onSubTabAdded', newSubTabKey, this.manualTab)
            this.close()
            this.$nextTick(() => {
              this.$v.$reset()
            })

            resolve(newSubTabKey)
          }
        )
      })

      if (this.createTable) {
        const gridId = this.$sanitize(this.title)
        const gridData = {
          title: this.title,
          storageType: 'dashboard',
          source: this.$sanitize(this.title),
          tab: this.currentTab,
          subtab: subTab,
          filterVisible: null,
          overflow: 'height:auto',
          gsOptions: {
            x: 0,
            y: 0,
            w: 24,
            h: 18,
          },
        }

        await db.dataGrid.widget.createNew(gridData)
        eventBus.$emit('dataGridAdded', gridId)

        this.createTable = false
        this.title = null
      }
    },
  },
  created() {
    eventBus.$on('showAddSubTabModal', tabKey => {
      if (tabKey) this.manualTab = tabKey
      this.open()
    })
  },
  validations: {
    title: {
      required,
      isUnique(value) {
        if (!this.title) return true
        if (!this.createTable) return true
        if (!this.dataGrid_options) return true

        const grids = Object.keys(this.dataGrid_options)

        if (!grids.includes(this.$sanitize(this.title))) return true

        return false
      },
      alphaNum,
    },
  },
}
</script>
